import React, { useState } from 'react'
import axios from "axios";
import { useForm } from "react-hook-form";
const FormRegistration = () => {
    const [loading, setLoading] = useState(false)
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data) => {
        console.log(data);
        setLoading(true);
        axios.post('https://millonabe.herokuapp.com/adduser', data, {
            headers: {
              "Content-Type": "application/json"
            }
          }).then((response)=>{
            window.location = response.data.consentUrl;
          }).catch((err)=>{
              alert("Facing some problem. Kindly re try");
              setLoading(false);
          });
         
        

    }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="mb-4">
                    <label className="form-label" htmlFor="name">
                        Name
              </label>
                    <input
                        className="form-control form-control-muted"
                        id="name"
                        {...register("name", { required: true })}
                    />
                    {errors.exampleRequired && <span>This field is required</span>}
                </div>

                <div className="mb-4">
                    <label className="form-label" htmlFor="password">
                        Gender
              </label>
                    <select className="form-control form-control-muted" {...register("gender")}>
                    <option value="male">male</option>
                        <option value="female">female</option>
                      
                        <option value="other">both</option>
                       
                    </select>
                </div>

                <div className="mb-4">
                    <label className="form-label" htmlFor="phone">
                        Phone
              </label>
                    <input
                        className="form-control form-control-muted"
                        id="mobileNumber"
                        {...register("mobileNumber", { required: true })}
                    />
                    {errors.phone && <span>This field is required</span>}
                </div>
                <div className="mb-4">
                    <label className="form-label" htmlFor="password">
                        Interested In
              </label>
                    <select className="form-control form-control-muted" {...register("interestedIn")}>
                    <option value="other">both</option>
                        <option value="female">female</option>
                        <option value="male">male</option>
                       
                    </select>
                </div>
                <div className="mb-4">
                    <label className="form-label" htmlFor="phone">
                        Password
              </label>
                    <input
                        className="form-control form-control-muted"
                        id="password"
                        {...register("password", { required: true })}
                    />
                    {errors.password && <span>This field is required</span>}
                </div>
                <div>
                    <button type="submit" className="btn btn-primary w-full">
                       Register & Verify
              </button>

              {loading && (
                  <p>Please Wait.... Registering your account</p>
              )}

                </div>

                {/* <div className="mb-4">
                    <div className="form-check">
                        <input
                            className="form-check-input"

                            name="check_example"
                            id="check_example"
                            type="checkbox" onclick="return false" checked
                        />
                        <label className="form-check-label" htmlFor="check_example">
                            Accept Tnc
                </label>
                    </div>
                </div> */}

            </form>
        </>
    )
}

export default FormRegistration
